"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  email: state => state.user.email,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  countries: state => state.facets.countries,
  genders: state => state.facets.genders,
  expiryTime: state => state.user.expiryTime,
  uuid: state => state.user.uuid,
  userMetadata: state => state.user.metadata,
  coachTools: stage => stage.facets.coachTools,
  givenName: state => state.user.givenName,
  familyName: state => state.user.familyName
};
var _default = exports.default = getters;